import styled from 'styled-components/macro'

export const CommentsStyled = styled.div``
